
import Icon from "../../../components/icon/index.vue";
import Navbar from "../../../components/navbar.vue";
import PasswordInput from "../../../components/inputs/password.vue";
import { ref } from "vue";
import { computed } from "vue";

export default {
  name: "RegisterByEmail",
  components: {
    Icon,
    Navbar,
    PasswordInput,
  },
  setup() {
    const form = ref({
      password: "",
    });

    const passwordReference = ref("");
    const doPasswordsMatch = computed(
      () => form.value.password === passwordReference.value,
    );

    return {
      form,
      passwordReference,
      doPasswordsMatch,
    };
  },
};
